import { DefaultService } from '@/services/DefaultService';

export default class AssPrazoPagamentoClienteService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/cliente/assprazopagtocliente.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/cliente/assprazopagtocliente.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    find(id) {
		return this._http.get(`${this._env}/ven/cliente/assprazopagtocliente/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(assprazopagtocliente) {
        return this._http.post(`${this._env}/ven/cliente/assprazopagtocliente/updatesituacao`, assprazopagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(assprazopagtocliente) {
        return this._http.post(`${this._env}/agro/cliente/assprazopagtocliente/updatesituacao`, assprazopagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(assprazopagtocliente) {
        return this._http.post(`${this._env}/ven/cliente/assprazopagtocliente`, assprazopagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(assprazopagtocliente) {
        return this._http.post(`${this._env}/agro/cliente/assprazopagtocliente`, assprazopagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosVendas(column, order, page, limit, idcliente, ...params) {
		return this._http.get( encodeURI(`${this._env}/ven/cliente/assprazopagtocliente/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    findNaoAssociadosAgro(column, order, page, limit, idcliente, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/cliente/assprazopagtocliente/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}
}